<template>
  <div class="subject-consumption">
    <div v-if="loading" class="loading">
      Načítavam dáta predmetov...
    </div>

    <div v-else-if="subjectData.length === 0" class="no-data">
      Žiadne dáta k dispozícii
    </div>

    <div v-else class="table-container">
      <table class="consumption-table">
        <thead>
          <tr>
            <th style="text-align: left;">Predmet</th>
            <th>Spotreba</th>
            <th></th>
            <th>Cena (€)</th>
            <th>%</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in sortedSubjectData" :key="index" class="data-row">
            <td class="subject-name">{{ item.subject_name }}</td>
            <td class="numeric">{{ item.energy_consumed.toFixed(3) }}</td>
            <td class="unit">{{ item.units }}</td>
            <td class="numeric price">{{ (item.energy_consumed * pricePerKwh).toFixed(2) }}</td>
            <td class="numeric percentage">{{ getPercentage(item.energy_consumed) }}%</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td>SPOLU</td>
            <td class="numeric">{{ totalConsumption.toFixed(3) }}</td>
            <td class="unit">kWh</td>
            <td class="numeric price">{{ (totalConsumption * pricePerKwh).toFixed(2) }}</td>
            <td class="numeric percentage">100%</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubjectConsumptionTable",

  props: {
    // Dáta prídu z rodiča (Dashboard), ktorý ich fetchuje raz pre oba komponenty
    subjectData: { type: Array,  default: () => [] },
    loading:     { type: Boolean, default: false   },
    pricePerKwh: { type: Number,  default: 0.20    },
  },

  computed: {
    sortedSubjectData() {
      return [...this.subjectData].sort((a, b) => b.energy_consumed - a.energy_consumed);
    },
    totalConsumption() {
      return this.subjectData.reduce((sum, item) => sum + item.energy_consumed, 0);
    },
  },

  watch: {
    totalConsumption(val) {
      // Emituj aktualizovanú sumu nahor kedykoľvek sa zmenia dáta
      this.$emit("subject-consumption-loaded", val);
    },
  },

  methods: {
    getPercentage(consumption) {
      if (this.totalConsumption === 0) return 0;
      return Math.round((consumption / this.totalConsumption) * 100);
    },
  },
};
</script>

<style scoped>
.subject-consumption { width: 100%; padding: 0; }
.loading, .no-data {
  text-align: center; color: #d1d5db; padding: 40px 0; font-size: 0.9rem;
}
.table-container { width: 100%; overflow-x: auto; }
.consumption-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
.consumption-table th {
  background-color: #1a2332; padding: 10px 12px; text-align: right;
  font-weight: 600; border-bottom: 1px solid #374151; color: #d1d5db;
}
.consumption-table th:last-child { text-align: right; }
.data-row { border-bottom: 1px solid #374151; }
.data-row:hover { background-color: rgba(99, 102, 241, 0.05); }
.consumption-table td { padding: 10px 12px; color: #f3f4f6; }
.subject-name { font-weight: 500; color: #f3f4f6; }
.numeric { text-align: right; font-family: monospace; color: #f3f4f6; }
.unit { text-align: left; color: #d1d5db; font-size: 0.85rem; }
.price { color: #f59e0b; font-weight: 600; }
.percentage { color: #6366f1; font-weight: 600; }
.total-row {
  background-color: #1a2332; font-weight: 700;
  border-top: 1px solid #374151; border-bottom: 1px solid #374151; color: #f3f4f6;
}
.total-row td { padding: 12px; color: #f3f4f6; }
@media (max-width: 768px) {
  .consumption-table { font-size: 0.85rem; }
  .consumption-table th, .consumption-table td { padding: 8px; }
}
</style>